"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTelefone = void 0;
var estiloInputTelefone = require("./InputTelefone.module.scss");
var react_1 = __importStar(require("react"));
var Label_1 = require("../../Label/Label");
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var HelperText_1 = require("../../HelperText/HelperText");
var InputTelefone = function (_a) {
    var id = _a.id, _b = _a.internacional, internacional = _b === void 0 ? false : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, _d = _a.texto, texto = _d === void 0 ? "" : _d, value = _a.value, _e = _a.label, label = _e === void 0 ? false : _e, posicaoLabel = _a.posicaoLabel, _f = _a.variante, variante = _f === void 0 ? "regular" : _f, _g = _a.desabilitado, desabilitado = _g === void 0 ? false : _g, _h = _a.tamanho, tamanho = _h === void 0 ? "medium" : _h, botaoDeLimpar = _a.botaoDeLimpar, conteudoAjuda = _a.conteudoAjuda, readOnly = _a.readOnly, autofocus = _a.autofocus, style = _a.style, onHover = _a.onHover, onChange = _a.onChange, onBlur = _a.onBlur, onSubmit = _a.onSubmit, onKeyDown = _a.onKeyDown;
    //region States
    var estiloVariacao = estiloInputTelefone[variante];
    var disabledStyle = estiloInputTelefone.desabilitado || "";
    var inputFieldSize = estiloInputTelefone[tamanho] || "";
    var inputFieldStyle = desabilitado ? disabledStyle : estiloVariacao;
    var _j = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _j[0], setCor = _j[1];
    var _k = react_1.default.useState('20px'), iconSize = _k[0], setIconSize = _k[1];
    var _l = (0, react_1.useState)(""), telefoneValor = _l[0], setTelefoneValor = _l[1];
    var _m = (0, react_1.useState)(false), isFocused = _m[0], setIsFocused = _m[1];
    var _o = (0, react_1.useState)({
        erro: false,
        mensagem: "",
    }), estadoErro = _o[0], setEstadoErro = _o[1];
    ("");
    var inputRef = (0, react_1.useRef)(null);
    //region Handlers
    var handleChange = function (e) {
        var apenasNumeros = e.target.value.replace(/\D/g, "");
        setTelefoneValor(apenasNumeros);
        onChange && onChange(apenasNumeros);
    };
    var handleFocus = function () {
        setIsFocused(true);
        setTelefoneValor(telefoneValor.replace(/\D/g, ""));
    };
    var handleBlur = (0, react_1.useCallback)(function (e) {
        if (telefoneValor === "") {
            return setEstadoErro({ erro: true, mensagem: "Insira um telefone." });
        }
        var valorFormatado = !internacional ? globalMu_1.default.formatarTelefone(telefoneValor) : telefoneValor;
        var telefoneValido = !internacional
            ? globalMu_1.default.validarTelefone(valorFormatado)
            : telefoneValor.length >= 5;
        if (telefoneValido) {
            setEstadoErro({ erro: false, mensagem: "" });
        }
        else {
            setEstadoErro({ erro: true, mensagem: "Insira um telefone válido." });
        }
        setTelefoneValor(valorFormatado);
    }, [telefoneValor, internacional]);
    var maxLength = internacional ? 15 : 14;
    var limparCampo = function () {
        setTelefoneValor("");
        onChange && onChange(null);
    };
    var ConteudoDeAjuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: conteudoAjuda ? conteudoAjuda === null || conteudoAjuda === void 0 ? void 0 : conteudoAjuda.texto : estadoErro.erro === true ? estadoErro.mensagem : '', desabilitado: conteudoAjuda ? conteudoAjuda === null || conteudoAjuda === void 0 ? void 0 : conteudoAjuda.desabilitado : desabilitado, estado: conteudoAjuda ? conteudoAjuda === null || conteudoAjuda === void 0 ? void 0 : conteudoAjuda.estado : "error", icone: conteudoAjuda ? conteudoAjuda === null || conteudoAjuda === void 0 ? void 0 : conteudoAjuda.icone : estadoErro.erro === true ? "warning" : undefined }));
    var BotaoLimpar = (react_1.default.createElement("div", { onClick: function () { return limparCampo(); }, className: "\n                ".concat(estiloInputTelefone.botaoLimpar, " \n                ").concat(inputFieldSize, " \n                ").concat(estiloVariacao, " \n                ").concat(desabilitado ? disabledStyle : '', "\n            ") },
        react_1.default.createElement(Icone_1.Icone, { nome: 'close', largura: iconSize, altura: iconSize, desabilitado: desabilitado, cor: cor, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    //region UseEffects
    (0, react_1.useEffect)(function () {
        setTelefoneValor(value !== null && value !== undefined ? value.toString() : "");
    }, [value]);
    (0, react_1.useEffect)(function () {
        switch (tamanho) {
            case 'small':
                setIconSize('16px');
                break;
            case 'medium':
                setIconSize('20px');
                break;
        }
    }, [tamanho]);
    (0, react_1.useEffect)(function () {
        desabilitado && setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        if (!desabilitado) {
            switch (variante) {
                case 'success':
                    setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    break;
                case 'error':
                    setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    break;
                case "regular":
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
            }
        }
    }, [variante, desabilitado]);
    //region Return
    return (react_1.default.createElement("div", { className: estiloInputTelefone.container },
        react_1.default.createElement("div", { className: estiloInputTelefone.conteudo, style: style },
            label && react_1.default.createElement(Label_1.Label, { texto: texto, negrito: 700, desabilitado: desabilitado }),
            react_1.default.createElement("div", { className: "\n                    ".concat(estiloInputTelefone.input, " \n                    ").concat(inputFieldSize, " \n                    ").concat(inputFieldStyle) },
                react_1.default.createElement("input", { id: id, ref: inputRef, type: "text", readOnly: readOnly, autoFocus: autofocus, disabled: desabilitado, maxLength: maxLength, value: telefoneValor, onChange: handleChange, onFocus: handleFocus, onBlur: !internacional ? handleBlur : onBlur, placeholder: placeholder }),
                botaoDeLimpar && !globalMu_1.default.isNullOrEmpty(telefoneValor) && BotaoLimpar))));
};
exports.InputTelefone = InputTelefone;
